const select =
  'created,generatedNumber,id,referenceEntity,referenceItemDescription,referenceItemId';

export default {
  paged: {
    select: `${select}`,
    searchSelect: [
      'sequenceItem/pattern',
      'generatedNumber',
      'referenceEntity',
      'referenceItemId',
      'referenceItemDescription',
    ],
    notSelectSearch: 'id,sequenceItem,referenceItemId',
    expand: {
      sequenceItem: { select: 'pattern' },
    },
  },
};
